import { MerchantUserType } from "@/models/club";

export const stylistMenuPaths = [
  "/dashboard",
  "/dashboard/calendar",
  "/dashboard/customers",
  "/dashboard/payments/add",
  "/dashboard/appointmentDeposit",
  "/dashboard/invoices",
  "/dashboard/marketing",
] as const;

export function hasManagerAccess(role?: MerchantUserType, isOwner = false) {
  return isOwner || role === MerchantUserType.Value0 || role === MerchantUserType.Value1;
}

const stylistRoutePaths = [
  ...stylistMenuPaths.filter(path => path !== "/dashboard"),
  "/dashboard/menu",
  "/dashboard/barber-overview",
  "/dashboard/padix-settlements",
  "/dashboard/factor",
  "/dashboard/schedule/add",
  "/dashboard/schedule/selectService",
  "/dashboard/schedule/selectTime",
  "/dashboard/schedule/save",
  "/dashboard/messages",
  "/dashboard/sendMessage",
  "/dashboard/areaMessage",
  "/dashboard/discount",
  "/dashboard/profile/autoMessage",
  "/dashboard/profile/template",
  "/dashboard/profile/customerGroup",
  "/dashboard/profile/importContact",
];

export function canStylistAccessRoute(pathname: string) {
  const path = pathname.replace(/\/+$/, "");
  return path === "/dashboard" || path === "/dashboard/schedule" ||
    stylistRoutePaths.some((root) => path === root || path.startsWith(`${root}/`));
}
